import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { cdnClient } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { useI18n } from '../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../context/occ/hooks/use-occ-config';
import { Image } from '../image/image';
import { AttributeType, getAttributeType, getHeroAttributeStyle } from './utils';
const b = bemClassBuilder('v-attribute');
export const Attribute = observer(props => {
    const i18n = useI18n();
    const { heroAttributeColours } = useOccConfig().showtime;
    const { attribute, showDetails, cdnOptions } = props;
    const type = getAttributeType(attribute);
    const name = i18n.translatable(attribute.name);
    const description = i18n.translatable(attribute.description);
    const iconStyle = type === AttributeType.Hero ? getHeroAttributeStyle(attribute, heroAttributeColours) : undefined;
    return (_jsxs("div", { className: b.block({ type, showDetails }), children: [_jsx("div", { className: b.element('icon', { type }), style: iconStyle, children: _jsx(Image, { className: b.element('img'), alt: name, title: name, src: cdnClient.instance.attribute(attribute.id).icon(cdnOptions) }) }), showDetails && (_jsxs("div", { className: b.element('details'), children: [_jsx("span", { className: b.element('name'), children: name }), description && _jsx("span", { className: b.element('description'), children: description })] }))] }));
});
Attribute.displayName = 'Attribute';
//# sourceMappingURL=attribute.js.map